import React, { Component } from 'react';
import Navbar from '../../components/navbar';
import { Link } from 'react-router-dom';
import { RedirectTo } from '../../util/utilLibrary';
import api from '../../services/api';

import { Form, FormGroup, Button, Spinner } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { formataDinheiro } from '../../util/formatacao';
import CardDetalhes from '../../components/cardDetalhes';
import Rodape from '../../components/rodape';
import { formataData } from '../../util/formatacao';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import BtnRodape from './components/btnRodape';
import { useState } from 'react';
import { useEffect } from 'react';

import { PDFDocument, encodeToBase64 } from 'pdf-lib'

library.add(fas);


function AprovaNotaFiscal(props) {
    const [state, setState] = useState();
    const [validando, setValidando] = useState();
    const [erro, setErro] = useState();
    const [warning, setWarning] = useState();
    const [btnAprovaDisabled, setBtnAprovaDisabled] = useState();
    const [notaFiscal, setNotaFiscal] = useState('');
    const [dados, setDados] = useState('');
    const [detalhes, setDetalhes] = useState('');
    const [carregando, setCarregando] = useState(true);
    const [notaAssinada, setNotaAssinada] = useState();
    const [aprovadoresNota, setAprovadoresNota] = useState([]);



    useEffect(() => {
        async function getDados() {
            setCarregando(true);
            let config = {
                headers: {
                    'IDMOV': props.match.params.idmov
                }
            }

            try {

                //faz a requisição
                const response = await api.get('/DetalheMovimentoAprovadores', config);
                setDados(response.data);
                console.log(response.data.codusuarioaprovadornota)
                setAprovadoresNota(response.data.codusuarioaprovadornota.split(" | "));
                console.log("111111111111", aprovadoresNota)

            }
            catch (err) {
                setValidando(false);
                setBtnAprovaDisabled(false);
                setErro("Erro ao efetuar aprovação, tente novamente mais tarde.")
                console.log(err);
            } finally {
                setCarregando(false);
            }
        }

        async function getDetalhesMovimento() {
            let config = {
                headers: {
                    'IDMOV': props.match.params.idmov,
                    'CODUSUARIO': sessionStorage.getItem('RC_USR'),
                }
            };

            try {

                //faz a requisição
                const response = await api.get('/DetalheMovimentoNF', config);
                setDetalhes(response.data);
            }
            catch (err) {
                setValidando(false);
                setBtnAprovaDisabled(false);
                setErro("Erro ao buscar a Nota Fiscal, tente novamente mais tarde.")
                console.log(err);

            }
        }

        getDados();
        getDetalhesMovimento();

    }, [props]);

    useEffect(() => {
        async function addAssinaturaPDF(nf) {
            // const assinatura1 = '../../assets/img/ass/ass1.png'
            // const assinatura1 = await readFileAsync('../../assets/img/ass/ass1.png');
            // const page = pdfDoc.addPage()
            const pdfDoc = await PDFDocument.load(nf.replace(/(\r\n|\n|\r)/gm, ""))
            const totalPages = pdfDoc.getPageCount()
            const page = pdfDoc.getPage(totalPages - 1);

            let msgWarning;
            let posicaoAssinatura = 1;
            for (const aprovador of aprovadoresNota) {
                let config = {
                    params: {
                        HASH: sessionStorage.getItem("RC_HASH") + Math.random(),
                        ALIAS: window.alias_RC,
                        CODUSUARIO: aprovador,
                    }
                }

                try {

                    //faz a requisição
                    const response = await api.get('/CarregaAssinatura', config);
                    if (response.data.CODIGO === "1") {
                        if (msgWarning) {
                            msgWarning = msgWarning + "O usuário: " + aprovador + " não possui nenhuma assinatura cadastrada no sistema.\n";
                        } else {
                            msgWarning = "O usuário: " + aprovador + " não possui nenhuma assinatura cadastrada no sistema.\n";
                        }
                    } else if (response.data.CODIGO != "2") {
                        // setAssinaturas(...assinaturas, response.data.ASSINATURA);
                        const assinaturaImage = await pdfDoc.embedPng(response.data.ASSINATURA);
                        const assinaturaDims = assinaturaImage.scale(0.25)

                        if (posicaoAssinatura == 1) {
                            page.drawImage(assinaturaImage, {
                                x: page.getWidth() - 200,
                                y: page.getHeight() - 755,
                                width: assinaturaDims.width,
                                height: assinaturaDims.height,
                            })
                        } else if (posicaoAssinatura == 2) {
                            page.drawImage(assinaturaImage, {
                                x: page.getWidth() - 100,
                                y: page.getHeight() - 755,
                                width: assinaturaDims.width,
                                height: assinaturaDims.height,
                            })
                        } else if(posicaoAssinatura == 3) {
                            page.drawImage(assinaturaImage, {
                                x: page.getWidth() - 200,
                                y: page.getHeight() - 955,
                                width: assinaturaDims.width,
                                height: assinaturaDims.height,
                            })
                        } else {
                            page.drawImage(assinaturaImage, {
                                x: page.getWidth() - 100,
                                y: page.getHeight() - 955,
                                width: assinaturaDims.width,
                                height: assinaturaDims.height,
                            })
                        }

                    }
                    posicaoAssinatura++;
                }
                catch (err) {
                    setValidando(false);
                    setBtnAprovaDisabled(false);
                    setErro("Erro ao buscar assinatura, tente novamente mais tarde.")
                    console.log(err);
                } finally {
                    if (msgWarning) {
                        setWarning(msgWarning);
                    }
                    setCarregando(false);
                }
            };

            const pdfBase64 = await pdfDoc.saveAsBase64()
            return pdfBase64;
        }

        async function getNotaFiscal() {

            let config = {
                headers: {
                    'IDMOV': props.match.params.idmov
                }
            }

            try {
                console.log(aprovadoresNota)
                //faz a requisição
                const response = await api.get('/NotaFiscalFornecedor', config);
                setNotaFiscal(response.data);

                const nfAssinada = await addAssinaturaPDF(response.data.arquivo);
                setNotaAssinada(nfAssinada)

            }
            catch (err) {
                setValidando(false);
                setBtnAprovaDisabled(false);
                setErro("Erro ao buscar a Nota Fiscal, tente novamente mais tarde.")
                console.log(err);
            }
        }

        getNotaFiscal();

    }, [aprovadoresNota])

    /*
    function convertImageToBase64(url) {
        return new Promise((resolve, reject) => {
            fetch(url)
                .then(response => response.blob())
                .then(blob => {
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        resolve(reader.result);
                    };
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    }
    */



    const marginInput = {
        marginBottom: "10px"
    }

    const boxNf = {
        border: "3px solid #c1c1c1",
        height: "100vh",
        width: "100%",
        fontWeight: "bold",
        overflowY: "scroll"
    }

    const centroCusto = {
        color: "#616161",
        textAlign: "center",
        fontSize: "14px"
    }
    let financeiro = props.match.params.financeiro;

    const rowInput = {
        paddingBottom: "10px"
    }

    const boxInputs = {
        width: "100%",
        padding: "0px",
        marginBottom: "15px"
    }

    const tituloCardDetalhes = () => {
        let tituloCardDetalhes;

        if (dados.numeronf && dados.dataemissaonf) {
            tituloCardDetalhes = props.match.params.desc + ": " + dados.numeronf;

        } else {
            tituloCardDetalhes = "DADOS NÃO ENCONTRADOS";
        }

        return tituloCardDetalhes;
    }

    let valorNF = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    }).format(props.match.params.valor);

    const ordenaDadosPorData = (dados) => {
        // Dividir a string em uma matriz de aprovações
        const approvalsArray = dados.split(' | ');

        // Extrair e analisar as datas de aprovação
        const approvalObjects = approvalsArray.map(approval => {
            const [name, dateStr] = approval.split(' Em: ');
            const [day, month, year, time] = dateStr.split(/[/\s]/);
            const date = new Date(`${year}-${month}-${day}T${time}`);
            return { name, date };
        });
        // Ordenar os dados de aprovação por data
        approvalObjects.sort((a, b) => a.date - b.date);

        let dadosTratados = "";
        approvalObjects.map((approval, index) => (
            dadosTratados = dadosTratados + approval.name + " - " + approval.date.toLocaleString().slice(0, -3) + "h\n"
        ));

        return dadosTratados;
    }

    return (
        <div>
            <Navbar />
            {carregando ?
                <>
                    <br />
                    <br />
                    <br />
                    <br />
                    <center >
                        <h4 style={{ color: "#007bff" }}>Carregando Informações...</h4>
                        <Spinner textAlign='center' animation="border" variant="primary" />
                    </center>
                    <br />
                </>
                :
                <>
                    <CardDetalhes
                        titulo={"Aprovação do: " + tituloCardDetalhes()}
                        exibe={true}
                        valor={valorNF.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                        valorTotal={dados.valortotalpedido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                        valorSaldo={dados.valorsaldopedido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                        btnImprimeVisible='false'
                    >

                        {erro && <div className="alert alert-danger" role="alert">Erro:
                            <FontAwesomeIcon className="mr-2" icon="times" />
                            {erro}
                        </div>}

                        {warning && <div className="alert alert-warning" role="alert">
                            <FontAwesomeIcon className="mr-2" icon="exclamation-triangle" />
                            {warning}
                        </div>}

                        <hr />
                        <br />

                        <Form>
                            <Row>

                                <Col lg={4} style={rowInput}>
                                    <Form.Label htmlFor="inputFornecedor"><b>Fornecedor:</b></Form.Label>
                                    <Form.Control readOnly id="inputFornecedor" value={dados.nomefornecedor ? dados.nomefornecedor : "Sem dados"} />
                                </Col>

                                <Col lg={2} style={rowInput}>
                                    <Form.Label htmlFor="inputDataEmissao"><b>Emissão:</b></Form.Label>
                                    <Form.Control readOnly id="inputDataEmissao" value={dados.dataemissaonf ? formataData(dados.dataemissaonf) : "Nenhum registro"} />
                                </Col>

                                <Col lg={2} style={rowInput}>
                                    <Form.Label htmlFor="inputPedido"><b>Pedido:</b></Form.Label>
                                    <Form.Control readOnly id="inputPedido" value={dados.numeropedido ? dados.numeropedido : "Nenhum registro"} />
                                </Col>

                                <Col lg={4} style={rowInput}>
                                    <Form.Label htmlFor="inputTipoPedido"><b>Tipo do Pedido:</b></Form.Label>
                                    <Form.Control readOnly id="inputTipoPedido" value={dados.tipopedido ? dados.tipopedido : "Nenhum registro"} />
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6} style={rowInput}>
                                    <Form.Label htmlFor="inputSolicitante"><b>Solicitante:</b></Form.Label>
                                    <Form.Control readOnly id="inputSolicitante" value={dados.solicitantes ? dados.solicitantes : "Dados Insuficentes"} />
                                </Col>

                                <Col lg={6} style={rowInput}>
                                    <Form.Label htmlFor="inputComprador"><b>Comprador:</b></Form.Label>
                                    <Form.Control readOnly id="inputComprador" value={dados.compradores ? dados.compradores : "Sem compradores"} />
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6} style={rowInput}>
                                    <Form.Label htmlFor="inputRecebedorFisico"><b>Rec. Físico:</b></Form.Label>
                                    <Form.Control readOnly id="inputRecebedorFisico" value={dados.recebedorfisico ? dados.recebedorfisico : "Dados não encontrados"} />
                                </Col>


                                <Col lg={6} style={rowInput}>
                                    <Form.Label htmlFor="inputRecebedorFiscal"><b>Rec. Fiscal:</b></Form.Label>
                                    <Form.Control readOnly id="inputRecebedorFiscal" value={dados.recebedorfiscal ? dados.recebedorfiscal : "Dados não encontrados"} />
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4} md={12} style={boxInputs}>
                                    <Col>
                                        <h4>Aprovação Pedido:</h4>
                                    </Col>

                                    <Col style={marginInput}>
                                        <Form.Control as="textarea" rows={4} readOnly id="inputAprovador1ped" value={dados.aprovadorespedido ? ordenaDadosPorData(dados.aprovadorespedido) : "Sem aprovadores para o pedido"} />
                                    </Col>
                                </Col>

                                <Col lg={4} md={12} style={boxInputs}>
                                    <Col>
                                        <h4>Aprovação Nota Fiscal:</h4>
                                    </Col>

                                    <Col style={marginInput}>
                                        <Form.Control as="textarea" rows={4} readOnly id="inputAprovador1nf" value={dados.aprovadoresnota ? ordenaDadosPorData(dados.aprovadoresnota) : "Sem aprovadores para a NF"} />
                                    </Col>
                                </Col>

                                <Col lg={4} md={12} style={boxInputs}>
                                    <Col>
                                        <h4>Aprovação Financeiro:</h4>
                                    </Col>

                                    <Col style={marginInput}>
                                        <Form.Control as="textarea" rows={4} readOnly id="inputAprovador1nf" value={dados.aprovadoresfinanceiro ? ordenaDadosPorData(dados.aprovadoresfinanceiro) : "Sem aprovadores Financeiros"} />
                                    </Col>
                                </Col>
                            </Row>
                            <hr />
                            <Row style={centroCusto}>
                                <p>Centro de custo: {props.match.params.centroCusto ? props.match.params.centroCusto.replaceAll("|", "/") : "NENHUM VALOR ENCONTRADO!"}</p>
                            </Row>
                            <Row style={boxNf}>
                                <embed src={"data:application/pdf;base64," + notaAssinada + "#view=FitH"} type="application/pdf" width="100%" heigh
                                    ="100%" />
                            </Row>

                            <br />

                            {erro && <div className="alert alert-danger" role="alert">Erro:
                                <FontAwesomeIcon className="mr-2" icon="times" />
                                {erro}
                            </div>}

                            {warning && <div className="alert alert-warning" role="alert">
                                <FontAwesomeIcon className="mr-2" icon="exclamation-triangle" />
                                {warning}
                            </div>}
                            <hr />
                            <div className="text-right">
                                <BtnRodape
                                    setValidando={setValidando}
                                    setBtnAprovaDisabled={setBtnAprovaDisabled}
                                    setErro={setErro}
                                    setWarning={setWarning}
                                    financeiro={financeiro}
                                    status={detalhes.statusmovimento}
                                    idmov={detalhes.idmov}
                                    numeromov={detalhes.numeromov}
                                    nomefantasia={detalhes.nomefantasia}
                                    valorliquido={props.match.params.valor}
                                    codtmv={detalhes.codtmv}
                                    usuariomestre={detalhes.usuariomestre}
                                    dependencia={detalhes.dependencia}
                                    idaprovacao={detalhes.idaprovacao}
                                    sequencial={detalhes.sequencial}
                                    codusuario={detalhes.codusuario}
                                    nomeVendedor={detalhes.nomeVendedor}
                                />
                            </div>
                        </Form>
                    </CardDetalhes>
                </>
            }
            <Rodape />

        </div>
    );

}

export default AprovaNotaFiscal;